import { render, staticRenderFns } from "./BetFeaturedPlayers.vue?vue&type=template&id=8180a4d4&scoped=true&"
import script from "./BetFeaturedPlayers.vue?vue&type=script&lang=js&"
export * from "./BetFeaturedPlayers.vue?vue&type=script&lang=js&"
import style0 from "./BetFeaturedPlayers.vue?vue&type=style&index=0&id=8180a4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8180a4d4",
  null
  
)

export default component.exports